import React, { useEffect } from "react";
import { connect } from "react-redux";
import HsNsComponent from "./HsNsComponent";
import { HsNsFunction } from "../../redux/index";
import { useParams } from "react-router";
import { EndPoints } from "../../utils/EndPoints";

function HsNsContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    // if (props.user.uid) {
    props.HsNsFunction("get", EndPoints["HsNs"]);
    // }
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <HsNsComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  HsNs: state.modules.HsNs,
  [EndPoints["HsNs"]]: state.modules[EndPoints["HsNs"]],
  loading: state.modules.loading,
});
const mapDispatchToProps = {
  HsNsFunction,
};

export default connect(mapStateToProps, mapDispatchToProps)(HsNsContainer);
